module.exports = __webpack_public_path__ + "img/step_1.ed44f328.png";